<template>
  <div class="w-full flex flex-wrap justify-between items-center py-4 rounded-lg mb-4">
    <div class=" flex items-center">
        <SocialMediaLogo styles="static w-10 h-10" :social="social"/>
    
      
      <div class="flex flex-col ml-4">
        <span class="font-bold text-sm md:text-normal text">{{JSON.parse(page.metadata).name}}</span>
        <span class=" font-light text-xs md:text-sm">{{ page.type | capitalize }}</span>
      </div>  
    </div>
    <div v-show="edit == 'edit'|| edit=='info' && !disable" class="flex items-center ">
      <VueToggles
      class="mt-2 md:mt-0"
      @click="toggleAddition"
      :value="isInPostingPages()"
      height="30"
      width="60"
      checkedText="On"
      uncheckedText="Off"
      checkedBg="#5BD9A4"
      uncheckedBg="lightgrey"
      />
    </div>
  </div>
</template>

<script>
import VueToggles from 'vue-toggles';

import SocialMediaLogo from "@/components/shared/SocialMediaLogo";
import TrashIcon from '@/components/svg/TrashIcon';

export default {
    name:"PlatfomrRow",

    components: {
      TrashIcon,
      VueToggles,
      SocialMediaLogo
  },
  
  data() {
    return {
      value: true,
    }
  },

  props: {
    edit: {
      type: String,
      required: true
    },
    social: {
      type: String,
      default: 'instagram'
    },
    page: {
      type: Object,
      required: true
    },
    postingPages: {
      type: Array,
      required: true
    },
    postId: {
      type: Number,
      required: true
    },
    disable: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    isInPostingPages() {
      return this.postingPages.filter(page => page.id === this.page.id).length > 0;
    },

    toggleAddition() {
      if(this.isInPostingPages()) {
        this.$inertia.put(this.$route('scheduler.posts.remove-page'), {'page_id': this.page.id, 'post_id': this.postId}, {preserveScroll: true});
      } else {
        this.$inertia.put(this.$route('scheduler.posts.add-page'), {'page_id': this.page.id, 'post_id': this.postId}, {preserveScroll: true});
      }
      this.$emit('changePage')
    }
  },


filters: {
  capitalize: function (value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}

}
</script>